module.exports = __webpack_public_path__ + "static/integration-24529c94e542d154003e1272ae181c8e.png";